import "./App.css";
import React from "react";
// import { Route, Switch, Redirect, useLocation} from 'react-router-dom'
import Home from "./home/Home";
import { HorseEdit, HorseIndex } from "./horse";
import { AuthorizationProvider } from "./authorization";
import { ShowEdit, ShowIndex } from "./show";
import DisciplineIndex from "./discipline/DisciplineIndex";
import { DisciplineEdit } from "./discipline";
import CompetitionIndex from "./competition/CompetitionIndex";
import { CompetitionEdit } from "./competition";
import { UserEdit, UserIndex } from "./user";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Login from "./login";
import AppLayout from "./applayout";
import NotFound from "./notfound";
import { AuthProvider } from "./auth/Authcontext";
import PrivateRoute from "./auth/PrivateRoute";
import { ToastContainer } from "react-toastify";
import Unauthorised from "./Unauthorised";
import UploadCompetition from "./competition/uploadCompetetion";
import UploadCompetitionHorse from "./competition/UploadCompetetionHorse";
import UploadHorse from "./horse/UploadHorse";
import InputResult from "./competition/InputResult";
import Manageadvertisment from "./tools/manageadvertisment";
import ResetScore from "./tools/resetscore";
import DeleteAccount from "./delete-account";
const App = () => {
  const location = useLocation();
  const pathname = location.pathname;

  return (
    <>
      {/* <AuthorizationProvider> */}
      <AuthProvider>
        <ToastContainer />

        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/delete-account" element={<DeleteAccount />} />
          <Route element={<AppLayout />}>
            {/* Replace Redirect with Navigate */}
            <Route
              path=":url*(/+)"
              element={<Navigate to={pathname.slice(0, -1)} />}
            />
            <Route
              path="/home"
              element={
                <PrivateRoute>
                  <Home />
                </PrivateRoute>
              }
            />
            <Route
              path="/tool/reset-score"
              element={
                <PrivateRoute>
                  <ResetScore />
                </PrivateRoute>
              }
            />

          <Route
              path="/tool/manage-advertisement-banner"
              element={
                <PrivateRoute>
                  <Manageadvertisment />
                </PrivateRoute>
              }
            />

            <Route
              path="/horse/:horseId"
              element={
                <PrivateRoute allowedRoles={"canUpdateHorse"}>
                  <HorseEdit />
                </PrivateRoute>
              }
            />
            <Route
              path="/horse"
              element={
                <PrivateRoute allowedRoles={"canCreateHorse"}>
                  <HorseIndex />
                </PrivateRoute>
              }
            />

            <Route
              path="/show/:showId"
              element={
                <PrivateRoute allowedRoles={"canUpdateShow"}>
                  <ShowEdit />
                </PrivateRoute>
              }
            />

            <Route
              path="/show"
              element={
                <PrivateRoute allowedRoles={"canCreateShow"}>
                  <ShowIndex />
                </PrivateRoute>
              }
            />

            <Route
              path="/competition/:competitionId"
              element={
                <PrivateRoute allowedRoles={"canCreateCompetition"}>
                  <CompetitionEdit />
                </PrivateRoute>
              }
            />
            <Route
              path="/competition"
              element={
                <PrivateRoute allowedRoles={"canCreateCompetition"}>
                  <CompetitionIndex />
                </PrivateRoute>
              }
            />

            <Route
              path="/competition/upload"
              element={
                <PrivateRoute allowedRoles={"canCreateCompetition"}>
                  <UploadCompetition />
                </PrivateRoute>
              }
            />

                        <Route
              path="/competition/horse/resultinput"
              element={
                <PrivateRoute allowedRoles={"canCreateCompetition"}>
                  <InputResult />
                </PrivateRoute>
              }
            />


            <Route
              path="/competition/horse/upload"
              element={
                <PrivateRoute allowedRoles={"canCreateCompetition"}>
                  <UploadCompetitionHorse />
                </PrivateRoute>
              }
            />

          <Route
              path="/horse/upload"
              element={
                <PrivateRoute allowedRoles={"canCreateCompetition"}>
                  <UploadHorse />
                </PrivateRoute>
              }
            />
            <Route
              path="/discipline/:disciplineId"
              element={
                <PrivateRoute allowedRoles={"canCreateDiscipline"}>
                  <DisciplineEdit />
                </PrivateRoute>
              }
            />
            <Route
              path="/discipline"
              element={
                <PrivateRoute allowedRoles={"canCreateDiscipline"}>
                  <DisciplineIndex />
                </PrivateRoute>
              }
            />

            <Route
              path="/user/:userId"
              element={
                <PrivateRoute allowedRoles={"canUpdateAnyUser"}>
                  <UserEdit />
                </PrivateRoute>
              }
            />
            <Route
              path="/user"
              element={
                <PrivateRoute allowedRoles={"canUpdateAnyUser"}>
                  <UserIndex />
                </PrivateRoute>
              }
            />
          </Route>

          <Route path="/unauthorized" element={<Unauthorised />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AuthProvider>
      {/* </AuthorizationProvider> */}
    </>
  );
};

export default App;
